import { render } from "./ConfettiContainer.vue?vue&type=template&id=56a6ad2c"
import script from "./ConfettiContainer.vue?vue&type=script&lang=js"
export * from "./ConfettiContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/projects/projects/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__